import { render, staticRenderFns } from "./QuestionnaireSetting.vue?vue&type=template&id=312a01ea&"
import script from "./QuestionnaireSetting.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireSetting.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports